var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHogar = function SvgIconHogar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 162 149.6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DA291C",
    d: "M73.4 4.2c2-1.6 3.9-3.7 6.5-4.1 2.4-.5 4.8.6 6.5 2.2 24.3 20.4 48.8 40.7 73.1 61.1 3.4 2.8 3.2 8.6-.3 11.2-2.6 2.2-6.2 1.4-9.3 1.5v66.1c.2 4-3.3 7.7-7.4 7.5H19.9c-3.9.2-7.4-3.2-7.4-7V76.2c-3-.1-6.2.6-8.9-1C1.5 74 .3 71.7.1 69.4v-1c.2-2.7 2.1-4.8 4.2-6.4 23-19.3 46-38.6 69.1-57.8m3.3 5.5L8 67c-.7.6-1.3 1.2-2 1.9l1.2.8c3.1.3 6.2-.1 9.2.2 1.6.3 2.6 1.9 2.4 3.4v68.4c0 .5 0 1.2.5 1.5 1.7.3 3.4.1 5.1.1H142c.8.1 1.6-.3 1.5-1.2V72.9c-.1-1.4 1.1-2.7 2.4-3 3-.3 6.2.2 9.2-.2 1-.6.2-1.5-.5-2L84.1 8.9c-1-.9-2-1.8-3.2-2.5-1.5.6-2.7 2.2-4.2 3.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#DA291C",
    d: "M61.7 81.7h38.6v64.6H61.7z",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })));
};
export default SvgIconHogar;